module.exports = __webpack_public_path__ + "static/img/みんな-2.00d734c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/みんな-2.jpg
// module id = /RZ8
// module chunks = 0